<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtPage />
    <SessionRecoveryOverlay />
  </div>
</template>
